module.exports = __webpack_public_path__ + "img/li6.b341821c.png";